/**
 * Derive whether the "free watch" trial still has time, using `/api/user/get` payload.
 * Backend should set remaining_user_time to 0 when the 2-day window ends; this also
 * honors explicit flags / end timestamps when the API sends them.
 */
const TRIAL_END_DATE_KEYS = [
  "free_watch_ends_at",
  "free_trial_end_at",
  "free_video_trial_end",
  "trial_end_date",
];

const TRIAL_START_DATE_KEYS = [
  "free_watch_started_at",
  "free_trial_start_at",
  "free_video_trial_start",
  "trial_start_date",
  "created_at",
  "createdAt",
  "registration_date",
  "joined_at",
];

export function resolveFreeWatchRemainingSeconds(profileData) {
  if (!profileData || typeof profileData !== "object") return 0;

  const expiredFlag =
    profileData.is_free_watch_expired === 1 ||
    profileData.is_free_watch_expired === true ||
    profileData.free_watch_expired === 1 ||
    profileData.free_watch_expired === true;

  if (expiredFlag) return 0;

  if (
    profileData.show_free_watch_popup === 0 ||
    profileData.show_free_watch_popup === false
  ) {
    return 0;
  }

  for (const key of TRIAL_END_DATE_KEYS) {
    const v = profileData[key];
    if (v == null || v === "") continue;
    const t = new Date(v).getTime();
    if (Number.isFinite(t) && Date.now() > t) return 0;
  }

  // Fallback guard: if we have a known start time and more than 48h passed,
  // do not show free-watch experience even if backend remaining_user_time is stale.
  for (const key of TRIAL_START_DATE_KEYS) {
    const v = profileData[key];
    if (v == null || v === "") continue;
    const t = new Date(v).getTime();
    if (!Number.isFinite(t)) continue;
    const elapsedMs = Date.now() - t;
    if (elapsedMs > 48 * 60 * 60 * 1000) return 0;
    break;
  }

  const raw = profileData.remaining_user_time;
  if (raw === null || raw === undefined || raw === "") return 0;

  // Strict numeric only. parseFloat("2 days") => 2 (wrong for this use-case).
  let n = 0;
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    const isStrictNumeric = /^-?\d+(\.\d+)?$/.test(trimmed);
    if (!isStrictNumeric) return 0;
    n = Number(trimmed);
  } else {
    n = Number(raw);
  }

  if (!Number.isFinite(n) || n <= 0) return 0;
  return n;
}
